import { render, staticRenderFns } from "./JobCardCompact.vue?vue&type=template&id=65b96b0c&"
import script from "./JobCardCompact.vue?vue&type=script&lang=js&"
export * from "./JobCardCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports